/** @jsxImportSource @emotion/react */
import { memo } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ShareChat } from '@trinity/chat-components/components/icons/ShareChat';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';
import { useTheme } from '@trinity/chat-components/components/Theme';
import { BaseMessageButton } from './Message.Button';

type Props = {
  className?: string;
  onClick: () => unknown;
  color?: string;
};

const size = 16;

export const ShareChatThread = memo(({ className, onClick, color }: Props) => {

  const theme = useTheme();

  return (
    <Tooltip title={`Share chat thread`}>
      <Root className={className} onClick={onClick}>
        <StyledShareIcon
          css={css({
            color: 'transparent',
            stroke: color ?? theme.palette.primary.light6,
          })}
          size={size} />
      </Root>
    </Tooltip>
  );
});

export const ShareButton = memo(({
  className,
  onClick,
}: Props) => {

  return (
    <BaseMessageButton className={className} onClick={onClick} css={compactContainerCss}>
      <StyledShareIcon size={size} />
      <ButtonShare>
        Share
      </ButtonShare>
    </BaseMessageButton>
  );
});

const Root = styled.div`
  cursor: pointer;
  transition: 0.3s;
`;

const StyledShareIcon = styled(ShareChat)(({ theme }) => `
  font-size: 18px !important;
`);

const compactContainerCss = css({
  '@container message-actions (max-width: 450px)': {
    minWidth: 'auto',
  },
});

const ButtonShare = styled.div({
  marginLeft: 5,
  '@container message-actions (max-width: 450px)': {
    display: 'inline-block',
    maxWidth: 0,
    overflow: 'hidden',
    opacity: 0,
    whiteSpace: 'nowrap',
    marginLeft: 0,
    transition: 'max-width 0.2s ease, opacity 0.2s ease, margin-left 0.2s ease',
    'button:hover &': {
      maxWidth: 100,
      opacity: 1,
      marginLeft: 5,
    },
  },
});

